import type { BookingConfirmationExtra } from '@massilia/queries'

import { Download, Package } from 'lucide-react'

import { centsToEuros, formatPrice } from '@/utils/format-price'

interface ExtrasSectionProps {
  extras: BookingConfirmationExtra[]
}

export function ExtrasSection({ extras }: ExtrasSectionProps) {
  if (extras.length === 0) return null

  return (
    <div className="flex flex-col gap-3 rounded-2xl border border-gray-light-200 bg-white p-6">
      <div className="text-lg leading-7 font-semibold text-gray-light-900 sm:text-2xl">
        Prestations supplémentaires
      </div>

      {extras.map((extra, i) => (
        <div key={i} className="flex flex-col gap-3 rounded-xl border border-gray-light-200 p-4">
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="flex size-9 items-center justify-center rounded-lg bg-indigo-50">
                <Package className="size-5 text-indigo-500" />
              </div>
              <div className="flex flex-col">
                <span className="text-sm font-semibold text-gray-light-900">{extra.name}</span>
                {extra.description && (
                  <span className="text-xs font-medium text-gray-light-600">
                    {extra.description}
                  </span>
                )}
                {extra.providerName && (
                  <span className="text-xs font-medium text-gray-light-600">
                    Prestataire : {extra.providerName}
                  </span>
                )}
                {extra.providerExternalRef && (
                  <span className="text-xs font-medium text-gray-light-600">
                    Réf. : {extra.providerExternalRef}
                  </span>
                )}
              </div>
            </div>
            <span className="shrink-0 text-sm font-bold text-gray-light-900">
              {formatPrice(centsToEuros(extra.price))}
            </span>
          </div>

          {/* File download link */}
          {extra.fileUrl && extra.fileName && (
            <a
              className="flex items-center gap-1.5 text-xs font-medium text-brand-600 hover:text-brand-700"
              href={extra.fileUrl}
              rel="noopener noreferrer"
              target="_blank"
            >
              <Download className="size-3.5" />
              <span className="max-w-[250px] truncate">{extra.fileName}</span>
            </a>
          )}
        </div>
      ))}
    </div>
  )
}
